// src/pages/History.jsx
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchMyDeliveryHistory,
  selectDeliveryHistoryFull,
  selectDriverLoading
} from '../store/slices/driverSlice';
import Navbar from '../components/common/Navbar';
import Loading from '../components/common/Loading';
import DriverHistory from '../components/driver/DriverHistory';
import { toast } from 'react-toastify';

const History = () => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    page: 1,
    limit: 20,
    status: '',
    start_date: '',
    end_date: ''
  });

  const history = useSelector(selectDeliveryHistoryFull);
  const loading = useSelector(selectDriverLoading);

  useEffect(() => {
    loadHistory();
  }, [filters]);

  const loadHistory = async () => {
    try {
      await dispatch(fetchMyDeliveryHistory(filters)).unwrap();
    } catch (error) {
      toast.error('Erreur lors du chargement de l\'historique');
    }
  };

  const handleFilterChange = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters, page: 1 }));
  };

  const handlePageChange = (newPage) => {
    setFilters(prev => ({ ...prev, page: newPage }));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">📋 Historique</h1>
          <p className="text-gray-600 mt-1">
            Consultez l'historique de toutes vos livraisons
          </p>
        </div>

        <DriverHistory 
          history={history}
          loading={loading.history}
          filters={filters}
          onFilterChange={handleFilterChange}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default History;